<template>
  <v2-container v-if="teams[$route.params.team].account">
    <v2-row>
      <v2-col col12>
        <v2-header-bar mobileFlyOut :titles="[{ label: $t('titles.dashboard') }]">
          <template v-slot:title>
            <v2-tooltip
              class="ml-2"
              :title="$t('tips.title')"
              :content="$t('tips.dashboard.quickLaunch') + '<br/>' + $t('tips.dashboard.addSomething')"
              v-if="showAlways || showTips"
              :show="showTips"
            ></v2-tooltip>
          </template>
          <template v-slot:right>
            <v2-button round icon secondary class="mr-2" @click.native="$goTo('QuickLaunch')"
              ><v2-icon :data="require('@icon/Icon=quick-launch.svg')" :original="true" fill></v2-icon>
            </v2-button>
            <v2-button
              class="relative mr-2"
              round
              icon
              primary
              @click.native.stop="$eventbus.$emit('toggleDropdown', actionsDropdownUid)"
              ><v2-icon :data="require('@icon/Icon=plus.svg')" color="#fff"></v2-icon>
              <v2-dropdown
                :dropdownUid="actionsDropdownUid"
                :dropdownData="dropdownData"
                :title="$t('actions.create')"
                :top="!isMdView ? '45px' : 'auto'"
                :right="!isMdView ? '0px' : '45px'"
                :bottom="!isMdView ? 'auto' : '0px'"
              ></v2-dropdown>
            </v2-button>
          </template>
        </v2-header-bar>
      </v2-col>
    </v2-row>
    <v2-row class="relative h-full" v-if="isCustomLoading">
      <v-spinner :loading="isCustomLoading"></v-spinner>
    </v2-row>
    <v2-row>
      <v2-col col12>
        <v2-card>
          <p
            v-html="
              $t('dashboard.texts.intro', {
                name: $h.formatName(teams[$route.params.team].account, true),
              })
            "
          ></p>
        </v2-card>
      </v2-col>
    </v2-row>
    <v2-row v-if="teamCan('project-statistics')">
      <v2-col col12>
        <h2 class="mb-0 flex items-center">
          {{ $t("dashboard.headings.stats") }}
          <v2-tooltip
            class="ml-2"
            :title="$t('tips.title')"
            :content="$t('tips.dashboard.stats')"
            v-if="showAlways || showTips"
            :show="showTips"
          ></v2-tooltip>
        </h2>
      </v2-col>
      <v2-col v-if="isLiveVisitorsCounterEnabled" class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=users.svg')"
          iconWidth="26px"
          :title="$t('projectsStats.liveVisitors')"
          :subtitle="$t('dashboard.stats.liveVisitors.subtitle')"
          :counter="{
            start: 0,
            end: liveVisitors.length,
            method: () => {
              goToProjectsFromSource('live-visitors');
            },
          }"
          customClass="dashboard-pageviews-doughnut-chart-number"
        >
        </v2-stats-card>
      </v2-col>
      <v2-col class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=eye.svg')"
          iconWidth="26px"
          :title="$t('projectsStats.pageviews')"
          :subtitle="$t('dashboard.stats.pageviews.subtitle')"
          customClass="dashboard-pageviews-doughnut-chart-number"
        >
          <template v-slot:custom>
            {{ projectsStats ? $h.formatNumber(projectsStats.pageviews.total, 1) : 0 }}
          </template>
          <template v-slot:chart v-if="projectsStats">
            <div>
              <v-doughnut-chart
                @click.native="goToProjects('pageviews')"
                v-if="pageviewsDoughnutChartData && pageviewsDoughnutChartData.datasets[0].data.length > 0"
                :data="pageviewsDoughnutChartData"
                :options="doughnutChartOptions"
                class="dashboard-pageviews-doughnut-chart"
              ></v-doughnut-chart>
            </div>
          </template>
        </v2-stats-card>
      </v2-col>
      <v2-col class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=folder.svg')"
          :iconFill="true"
          :title="$t('projectsStats.projects')"
          :subtitle="$t('dashboard.stats.projects.subtitle')"
          :customClass="!projectsStats ? 'dashboard-pageviews-doughnut-chart-number' : ''"
        >
          <template v-slot:custom v-if="!projectsStats">0</template>
          <template v-slot:chart v-if="projectsStats">
            <v-horizontal-bar-chart
              @click.native="goToProjects('projects')"
              :data="projectsBarChartData"
              :options="barChartOptions"
              class="dashboard-projects-bar-chart"
            >
            </v-horizontal-bar-chart>
          </template>
        </v2-stats-card>
      </v2-col>
      <v2-col v-if="isImportantProjectsWidgetsEnabled" class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=bulb.svg')"
          iconWidth="30px"
          :title="$t('labels.importantProjectsWidgetHeader')"
          :subtitle="$t('labels.importantProjectsWidgetSubHeader')"
          :customClass="!projectsStats ? 'dashboard-pageviews-doughnut-chart-number' : ''"
        >
          <template v-slot:custom v-if="!projectsStats">0</template>
          <template v-slot:chart v-if="projectsStats">
            <div class="flex mb-3 w-full justify-end items-end">
              <div class="flex ml-1 w-1/4">
                <div
                  :class="[
                    'important-project-chart-item',
                    'mt-0',
                    projectHotLeadsCount === 0 ? 'opacity-25' : 'important-project-chart-item-active',
                  ]"
                  style="
                    padding-top: 7px;
                    width: 50px;
                    height: 50px;
                    text-align: center;
                    font-size: 24px;
                    background-color: #f6cc79;
                    color: #ffffff;
                    border-radius: 50%;
                  "
                  @click="goToProjectsFromSource('hot-projects')"
                >
                  {{ projectHotLeadsCount }}
                </div>
              </div>

              <div class="flex w-2/4 self-center">
                <div style="font-size: 14px">
                  {{ $t("labels.importantProjectsWidgetHot") }}
                </div>
              </div>
            </div>

            <div class="flex mb-3 w-full justify-end items-end">
              <div class="flex ml-1 w-1/4">
                <div
                  :class="[
                    'important-project-chart-item',
                    'mt-0',
                    projectActionRequiredLeadsCount === 0 ? 'opacity-25' : 'important-project-chart-item-active',
                  ]"
                  style="
                    padding-top: 7px;
                    width: 50px;
                    height: 50px;
                    text-align: center;
                    font-size: 24px;
                    background-color: #45547d;
                    color: #ffffff;
                    border-radius: 50%;
                  "
                  @click="goToProjectsFromSource('action-required-projects')"
                >
                  {{ projectActionRequiredLeadsCount }}
                </div>
              </div>

              <div class="flex w-2/4 self-center">
                <div style="font-size: 14px">
                  {{ $t("labels.importantProjectsWidgetActionRequired") }}
                </div>
              </div>
            </div>

            <div class="flex w-full justify-end items-end">
              <div class="flex ml-1 w-1/4">
                <div
                  :class="[
                    'important-project-chart-item',
                    'mt-0',
                    projectDeadLeadsCount === 0 ? 'opacity-25' : 'important-project-chart-item-active',
                  ]"
                  style="
                    padding-top: 7px;
                    width: 50px;
                    height: 50px;
                    text-align: center;
                    font-size: 24px;
                    background-color: #aa0000;
                    color: #ffffff;
                    border-radius: 50%;
                  "
                  @click="goToProjectsFromSource('dead-projects')"
                >
                  {{ projectDeadLeadsCount }}
                </div>
              </div>

              <div class="flex w-2/4 self-center">
                <div style="font-size: 14px">
                  {{ $t("labels.importantProjectsWidgetDead") }}
                </div>
              </div>
            </div>
          </template>
        </v2-stats-card>
      </v2-col>

      <v2-col class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=message.svg')"
          :iconFill="true"
          :title="$t('projectsStats.messages')"
          :subtitle="$t('dashboard.stats.messages.subtitle')"
          :customClass="!projectsStats ? 'dashboard-pageviews-doughnut-chart-number' : ''"
        >
          <template v-slot:custom v-if="!projectsStats">0</template>
          <template v-slot:chart v-if="projectsStats">
            <v-horizontal-bar-chart
              @click.native="goToProjects('messages')"
              :data="messagesBarChartData"
              :options="barChartOptions"
              class="dashboard-messages-bar-chart"
            >
            </v-horizontal-bar-chart>
          </template>
        </v2-stats-card>
      </v2-col>
      <v2-col v-if="isHeatmapChartEnabled" class="w-full md:w-1/2 lg:w-1/3 xl:w-1/4">
        <v2-stats-card
          fullWidth
          :icon="require('@icon/Icon=calendar.svg')"
          :title="$t('projectsStats.interactions')"
          :subtitle="$t('dashboard.stats.interactions.subtitle')"
          :customClass="!projectsStats ? 'dashboard-pageviews-doughnut-chart-number' : ''"
        >
          <template v-slot:custom v-if="!projectsStats">0</template>
          <template v-slot:chart v-if="projectsStats">
            <v2-heatmap :series="heatmapData" :options="heatmapOptions"></v2-heatmap>
          </template>
        </v2-stats-card>
      </v2-col>
      <!--      <v2-col class="justify-center items-center">-->
      <!--        <v-icon-->
      <!--          name="lock"-->
      <!--          width="80"-->
      <!--          height="80"-->
      <!--          class="absolute z-50"-->
      <!--        ></v-icon>-->
      <!--        <div class="stats-teaser created-projects"></div>-->
      <!--      </v2-col>-->
      <!--      <v2-col class="justify-center items-center">-->
      <!--        <v-icon-->
      <!--          name="lock"-->
      <!--          width="80"-->
      <!--          height="80"-->
      <!--          class="absolute z-50"-->
      <!--        ></v-icon>-->
      <!--        <div class="stats-teaser project-status"></div>-->
      <!--      </v2-col>-->
      <!--      <v2-col class="justify-center items-center">-->
      <!--        <v-icon-->
      <!--          name="lock"-->
      <!--          width="80"-->
      <!--          height="80"-->
      <!--          class="absolute z-50"-->
      <!--        ></v-icon>-->
      <!--        <div class="stats-teaser created-projects"></div>-->
      <!--      </v2-col>-->
    </v2-row>
    <v2-row>
      <v2-col col12>
        <h2>{{ $t("dashboard.titles.ctas") }}</h2>
      </v2-col>
      <v2-col>
        <v2-button secondary class="w-270px sm:w-335px" @click.native="$goTo('QuickLaunch')">{{
          $t("dashboard.actions.quickLaunch")
        }}</v2-button>
      </v2-col>
      <v2-col>
        <v2-button secondary class="w-270px sm:w-335px" @click.native="$goTo('Clients')">{{
          $t("dashboard.actions.customers")
        }}</v2-button>
      </v2-col>
      <v2-col>
        <v2-button secondary class="w-270px sm:w-335px" @click.native="$goTo('Projects')">{{
          $t("dashboard.actions.projects")
        }}</v2-button>
      </v2-col>
    </v2-row>
    <!--    <v2-row>-->
    <!--      <v2-col col12>-->
    <!--        <h2>{{ $t("dashboard.titles.activities") }}</h2>-->
    <!--        <v2-card>-->
    <!--          <ul class="list">-->
    <!--            <div-->
    <!--              v-for="feed in activityFeedItemsForDropdown.items"-->
    <!--              :key="feed.uid"-->
    <!--            >-->
    <!--              <v2-list-item v-if="feed.events.FileDownload[0]">-->
    <!--                <v2-list-cell icon="upload" rotate />-->
    <!--                <v2-list-cell class="flex-1">-->
    <!--                  <template v-slot:value>-->
    <!--                    <i18n path="dashboard.activities.fileDownload" tag="div">-->
    <!--                      <template v-slot:name>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Client',-->
    <!--                            params: { uid: feed.client.uid }-->
    <!--                          }"-->
    <!--                          >{{ $h.formatName(feed.client, true) }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:filename>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'filedownloads'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{-->
    <!--                            feed.events.FileDownload[0].file.title-->
    <!--                          }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:projectname>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: { uid: feed.project.uid, tab: 'overview' }-->
    <!--                          }"-->
    <!--                          >{{ feed.project.title }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:num>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'filedownloads'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{-->
    <!--                            feed.events.FileDownload.length - 1-->
    <!--                          }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                    </i18n>-->
    <!--                  </template>-->
    <!--                </v2-list-cell>-->
    <!--                <v2-list-cell-->
    <!--                  :value="-->
    <!--                    $h.formatDate(-->
    <!--                      feed.latest_event_at,-->
    <!--                      teams[$route.params.team].account.timezone,-->
    <!--                      true-->
    <!--                    )-->
    <!--                  "-->
    <!--                >-->
    <!--                </v2-list-cell>-->
    <!--              </v2-list-item>-->
    <!--              <v2-list-item v-if="feed.events.FileUpload[0]">-->
    <!--                <v2-list-cell icon="upload" />-->
    <!--                <v2-list-cell class="flex-1">-->
    <!--                  <template v-slot:value>-->
    <!--                    <i18n path="dashboard.activities.fileUpload" tag="div">-->
    <!--                      <template v-slot:name>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Client',-->
    <!--                            params: { uid: feed.client.uid }-->
    <!--                          }"-->
    <!--                          >{{ $h.formatName(feed.client, true) }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:filename>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'fileuploads'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{-->
    <!--                            feed.events.FileUpload[0].file.title-->
    <!--                          }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:projectname>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: { uid: feed.project.uid, tab: 'overview' }-->
    <!--                          }"-->
    <!--                          >{{ feed.project.title }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:num>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'fileuploads'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{ feed.events.FileUpload.length - 1 }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                    </i18n>-->
    <!--                  </template>-->
    <!--                </v2-list-cell>-->
    <!--                <v2-list-cell-->
    <!--                  :value="-->
    <!--                    $h.formatDate(-->
    <!--                      feed.latest_event_at,-->
    <!--                      teams[$route.params.team].account.timezone,-->
    <!--                      true-->
    <!--                    )-->
    <!--                  "-->
    <!--                >-->
    <!--                </v2-list-cell>-->
    <!--              </v2-list-item>-->
    <!--              <v2-list-item v-if="feed.events.PageView[0]">-->
    <!--                <v2-list-cell icon="preview" />-->
    <!--                <v2-list-cell class="flex-1">-->
    <!--                  <template v-slot:value>-->
    <!--                    <i18n path="dashboard.activities.pageView" tag="div">-->
    <!--                      <template v-slot:name>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Client',-->
    <!--                            params: { uid: feed.client.uid }-->
    <!--                          }"-->
    <!--                          >{{ $h.formatName(feed.client, true) }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:pagename>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'pageviews'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{ feed.events.PageView[0].page.name }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:projectname>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: { uid: feed.project.uid, tab: 'overview' }-->
    <!--                          }"-->
    <!--                          >{{ feed.project.title }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:num>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: {-->
    <!--                              uid: feed.project.uid,-->
    <!--                              tab: 'history',-->
    <!--                              subtab: 'pageviews'-->
    <!--                            }-->
    <!--                          }"-->
    <!--                          >{{ feed.events.PageView.length - 1 }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                    </i18n>-->
    <!--                  </template>-->
    <!--                </v2-list-cell>-->
    <!--                <v2-list-cell-->
    <!--                  :value="-->
    <!--                    $h.formatDate(-->
    <!--                      feed.latest_event_at,-->
    <!--                      teams[$route.params.team].account.timezone,-->
    <!--                      true-->
    <!--                    )-->
    <!--                  "-->
    <!--                >-->
    <!--                </v2-list-cell>-->
    <!--              </v2-list-item>-->
    <!--              <v2-list-item v-if="feed.events.ProjectMessage[0]">-->
    <!--                <v2-list-cell icon="comment" />-->
    <!--                <v2-list-cell class="flex-1">-->
    <!--                  <template v-slot:value>-->
    <!--                    <i18n path="dashboard.activities.projectMessage" tag="div">-->
    <!--                      <template v-slot:name>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Client',-->
    <!--                            params: { uid: feed.client.uid }-->
    <!--                          }"-->
    <!--                          >{{ $h.formatName(feed.client, true) }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:projectname>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: { uid: feed.project.uid, tab: 'overview' }-->
    <!--                          }"-->
    <!--                          >{{ feed.project.title }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                      <template v-slot:num>-->
    <!--                        <router-link-->
    <!--                          class="secondary"-->
    <!--                          :to="{-->
    <!--                            name: 'Project',-->
    <!--                            params: { uid: feed.project.uid, tab: 'chat' }-->
    <!--                          }"-->
    <!--                          >{{-->
    <!--                            feed.events.ProjectMessage.length - 1-->
    <!--                          }}</router-link-->
    <!--                        >-->
    <!--                      </template>-->
    <!--                    </i18n>-->
    <!--                  </template>-->
    <!--                </v2-list-cell>-->
    <!--                <v2-list-cell-->
    <!--                  :value="-->
    <!--                    $h.formatDate(-->
    <!--                      feed.latest_event_at,-->
    <!--                      teams[$route.params.team].account.timezone,-->
    <!--                      true-->
    <!--                    )-->
    <!--                  "-->
    <!--                >-->
    <!--                </v2-list-cell>-->
    <!--              </v2-list-item>-->
    <!--            </div>-->
    <!--            <v2-list-item v-if="!activityFeedItemsForDropdown.items.length">-->
    <!--              <v2-list-cell :value="$t('placeholders.noFeeds')"></v2-list-cell>-->
    <!--            </v2-list-item>-->
    <!--          </ul>-->
    <!--        </v2-card>-->
    <!--      </v2-col>-->
    <!--    </v2-row>-->
    <v-row>
      <v2-col col12>
        <h2 class="mb-0 flex items-center">
          {{ $t("dashboard.headings.activityFeeds") }}
          <v2-tooltip
            class="ml-2"
            :title="$t('tips.title')"
            :content="$t('tips.dashboard.activities')"
            v-if="showAlways || showTips"
            :show="showTips"
          ></v2-tooltip>
        </h2>
      </v2-col>
      <v2-col col12>
        <v-list-header complex>
          <v-list-header-cell emptyIcon />
          <v-list-header-cell :title="$t('client.client')" />
          <v-list-header-cell :title="$t('client.project')" />
          <v-list-header-cell emptyTitle size="4" />
        </v-list-header>
        <ul class="list">
          <div v-for="feed in activityFeedItemsForDropdown.items" :key="feed.uid">
            <v-list-item v-if="feed.events.FileDownload[0]" complex flexibleHeight>
              <v-list-cell icon="Icon=download.svg" iconColor="#5057af" />
              <v-list-cell
                :valueRoute="{
                  name: 'Client',
                  params: { uid: feed.client.uid },
                }"
                :value="$h.formatName(feed.client, true)"
              />
              <v-list-cell
                :valueRoute="{
                  name: 'Project',
                  params: { uid: feed.project.uid, tab: 'overview' },
                }"
                :value="feed.project.title"
              />
              <v-list-cell
                size="4"
                mobile
                :truncate="false"
                :valueRoute="{
                  name: 'Project',
                  params: {
                    uid: feed.project.uid,
                    tab: 'history',
                    subtab: 'filedownloads',
                  },
                }"
                :value="
                  $tc('activity.fileDownload.dropdownText', feed.events.FileDownload.length, {
                    beforeText: setText($h.formatName(feed.client, true), feed.project.title),
                    name: feed.events.FileDownload[0].file.title,
                    num: feed.events.FileDownload.length,
                  })
                "
                :subvalue="$h.formatDate(feed.latest_event_at, teams[$route.params.team].account.timezone, true)"
              />
            </v-list-item>
            <v-list-item v-if="feed.events.FileUpload[0]" complex>
              <v-list-cell icon="Icon=share.svg" iconColor="#5057af" />
              <v-list-cell
                :valueRoute="{
                  name: 'Client',
                  params: { uid: feed.client.uid },
                }"
                :value="$h.formatName(feed.client, true)"
              />
              <v-list-cell
                :valueRoute="{
                  name: 'Project',
                  params: { uid: feed.project.uid, tab: 'overview' },
                }"
                :value="feed.project.title"
              />
              <v-list-cell
                size="4"
                mobile
                :valueRoute="{
                  name: 'Project',
                  params: {
                    uid: feed.project.uid,
                    tab: 'history',
                    subtab: 'fileuploads',
                  },
                }"
                :value="
                  $tc('activity.fileUpload.dropdownText', feed.events.FileUpload.length, {
                    beforeText: setText($h.formatName(feed.client, true), feed.project.title),
                    name: feed.events.FileUpload[0].file.title,
                    num: feed.events.FileUpload.length,
                  })
                "
                :subvalue="$h.formatDate(feed.latest_event_at, teams[$route.params.team].account.timezone, true)"
              />
            </v-list-item>
            <v-list-item v-if="feed.events.PageView[0]" complex>
              <v-list-cell icon="Icon=eye.svg" iconColor="#5057AF" iconOriginal />
              <v-list-cell
                :valueRoute="{
                  name: 'Client',
                  params: { uid: feed.client.uid },
                }"
                :value="$h.formatName(feed.client, true)"
              />
              <v-list-cell
                :value="feed.project.title"
                :valueRoute="{
                  name: 'Project',
                  params: { uid: feed.project.uid, tab: 'overview' },
                }"
              />
              <v-list-cell
                size="4"
                mobile
                :valueRoute="{
                  name: 'Project',
                  params: {
                    uid: feed.project.uid,
                    tab: 'history',
                    subtab: 'pageviews',
                  },
                }"
                :value="
                  $tc('activity.pageView.dropdownText', feed.events.PageView.length, {
                    beforeText: setText($h.formatName(feed.client, true), feed.project.title),
                    name: feed.events.PageView[0].page.name,
                    num: feed.events.PageView.length,
                  })
                "
                :subvalue="$h.formatDate(feed.latest_event_at, teams[$route.params.team].account.timezone, true)"
              />
            </v-list-item>
            <v-list-item v-if="feed.events.FormResponse[0]" complex>
              <v-list-cell icon="Icon=pen-field.svg" iconColor="#5057AF" iconOriginal />
              <v-list-cell
                :valueRoute="{
                  name: 'Client',
                  params: { uid: feed.client.uid },
                }"
                :value="$h.formatName(feed.client, true)"
              />
              <v-list-cell
                :value="feed.project.title"
                :valueRoute="{
                  name: 'Project',
                  params: { uid: feed.project.uid, tab: 'overview' },
                }"
              />
              <v-list-cell
                size="4"
                mobile
                :valueRoute="{
                  name: 'Project',
                  params: {
                    uid: feed.project.uid,
                    tab: 'history',
                    subtab: 'all',
                  },
                }"
                :value="
                  $tc('activity.formResponse.dropdownText', feed.events.FormResponse.length, {
                    beforeText: setText($h.formatName(feed.client, true), feed.project.title),
                    num: feed.events.FormResponse.length,
                  })
                "
                :subvalue="$h.formatDate(feed.latest_event_at, teams[$route.params.team].account.timezone, true)"
              />
            </v-list-item>
            <v-list-item v-if="feed.events.ProjectMessage[0]" complex>
              <v-list-cell icon="Icon=message.svg" iconColor="#5057af" />
              <v-list-cell
                :valueRoute="{
                  name: 'Project',
                  params: { uid: feed.project.uid, tab: 'overview' },
                }"
                :value="feed.project.title"
              />
              <v-list-cell
                :valueRoute="{
                  name: 'Client',
                  params: { uid: feed.client.uid },
                }"
                :value="$h.formatName(feed.client, true)"
              />
              <v-list-cell
                size="4"
                mobile
                :valueRoute="{
                  name: 'Inbox',
                  query: { uid: feed.project.uid },
                }"
                :value="
                  $tc('activity.projectMessage.dropdownText', feed.events.ProjectMessage.length, {
                    beforeText: setText($h.formatName(feed.client, true), feed.project.title),
                    message: feed.events.ProjectMessage[0].message.body.replace(/<br\/>/gi, ''),
                    num: feed.events.ProjectMessage.length,
                  })
                "
                :subvalue="$h.formatDate(feed.latest_event_at, teams[$route.params.team].account.timezone, true)"
              />
            </v-list-item>
          </div>
          <v-list-item v-if="!activityFeedItemsForDropdown.items.length">
            <v-list-cell :value="$t('placeholders.noFeeds')"></v-list-cell>
          </v-list-item>
        </ul>
      </v2-col>
    </v-row>
    <v2-row>
      <v2-col col12>
        <h2 class="flex items-center">
          {{ $t("dashboard.headings.academy") }}
          <v2-tooltip
            class="ml-2"
            :title="$t('tips.title')"
            :content="$t('tips.dashboard.news')"
            v-if="showAlways || showTips"
            :show="showTips"
          ></v2-tooltip>
        </h2>
        <h3 class="mb-4">{{ $t("dashboard.subHeadings.academy") }}</h3>
        <v2-col col12 noSpaceX>
          <div class="embed-container" v-if="teams[$route.params.team].account.locale === 'en'">
            <iframe
              slot="content"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/videoseries?list=PLfq0v3RCl0AnCtCPZ9Az9nY2buNFu22Gm"
              frameborder="0"
              allow="autoplay; encrypted-media"
              webkitAllowFullScreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
          <div class="embed-container" v-if="teams[$route.params.team].account.locale === 'de'">
            <iframe
              slot="content"
              width="560"
              height="315"
              src="https://www.youtube.com/embed/videoseries?list=PLfq0v3RCl0AkJL3vNyE1U_Ij5Hbfc8ud3"
              frameborder="0"
              allow="autoplay; encrypted-media"
              webkitAllowFullScreen
              mozallowfullscreen
              allowfullscreen
            ></iframe>
          </div>
        </v2-col>
      </v2-col>
      <v2-col col12>
        <h2 class="mb-2">{{ $t("dashboard.headings.followUs") }}</h2>
        <div class="flex flex-wrap">
          <a href="https://www.facebook.com/envivo.io" target="_blank" class="secondary mr-4 flex items-center text-xl">
            <div class="w-8 h-8 rounded-full bg-v2-cta-blue flex justify-center items-center text-white mr-1">
              <v2-icon
                :data="require('@icon/Icon=facebook.svg')"
                fill
                color="#fff"
                width="24px"
                height="auto"
              ></v2-icon>
            </div>
            {{ $t("dashboard.actions.facebook") }}</a
          >
          <a href="https://bit.ly/3ys0TGV" target="_blank" class="secondary mr-4 flex items-center text-xl">
            <div class="w-8 h-8 rounded-full bg-v2-cta-blue flex justify-center items-center text-white mr-1">
              <v2-icon
                :data="require('@icon/Icon=linkedin.svg')"
                fill
                class="show-stroke"
                color="#fff"
                width="20px"
                height="auto"
              ></v2-icon>
            </div>
            {{ $t("dashboard.actions.linkedin") }}</a
          >
          <a href="https://bit.ly/2Rui9uO" target="_blank" class="secondary mr-4 flex items-center text-xl">
            <div class="w-8 h-8 rounded-full bg-v2-cta-blue flex justify-center items-center text-white mr-1">
              <v2-icon :data="require('@icon/Icon=youtube.svg')" color="#fff" width="20px" height="auto"></v2-icon>
            </div>
            {{ $t("dashboard.actions.youtube") }}</a
          >
        </div>
      </v2-col>
    </v2-row>
  </v2-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import global from "../mixins/global.js";
import teamAbilities from "@/mixins/teamAbilities";

export default {
  name: "Dashboard",
  mixins: [global, teamAbilities],
  data() {
    return {
      isCustomLoading: false,
      actionsDropdownUid: this.$h.createUniqueUid(),
      dropdownData: [
        {
          route: { name: "createClient" },
          name: this.$t("dashboard.dropdowns.customer"),
        },
        {
          route: { name: "createProject" },
          name: this.$t("dashboard.dropdowns.project"),
        },
        {
          route: { name: "createTemplate" },
          name: this.$t("dashboard.dropdowns.template"),
        },
        {
          route: { name: "createContact" },
          name: this.$t("dashboard.dropdowns.contact"),
        },
        {
          route: { name: "Settings", params: { tab: "team" } },
          name: this.$t("dashboard.dropdowns.member"),
        },
      ],
      chartsBackgroundColors: [
        "#2F98E8",
        "#154469",
        "#76B9EC",
        "#EAD3B8",
        "#AC998C",
        "#615480",
        "#C2D2BE",
        "#42B8B8",
        "#8E5CFF",
        "#C2C4C8",
        "#462E80",
      ],
      projectChartBackgroundColors: ["#FC6D6D", "#F6CD79", "#13C46A"],
      pageviewsDoughnutChartData: null,
      projectsBarChartData: null,
      messagesBarChartData: null,
      initDoughnutChartData: {
        labels: [],
        extraLabels: [],
        filterKey: "",
        filterValues: [],
        datasets: [
          {
            data: [],
          },
        ],
      },
      initBarChartData: {
        labels: [],
        extraLabels: [],
        filterKey: "",
        filterValues: [],
        datasets: [
          {
            data: [],
          },
        ],
      },
      doughnutChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        tooltips: {
          bodyFontFamily: "Cabin",
          displayColors: false,
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.extraLabels[tooltipItem.index] || "";
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value + " " + label;
            },
            title: () => {
              return "";
            },
          },
        },
        plugins: {
          datalabels: {
            display: false,
          },
        },
      },
      barChartOptions: {
        maintainAspectRatio: false,
        legend: {
          display: false,
        },
        scales: {
          yAxes: [
            {
              beginAtZero: true,
              gridLines: {
                display: false,
              },
              barThickness: 20,
              ticks: {
                fontFamily: "Cabin",
                fontStyle: "bold",
              },
            },
          ],
          xAxes: [
            {
              gridLines: {
                color: "#eee",
              },
              ticks: {
                display: false,
                beginAtZero: true,
              },
            },
          ],
        },
        tooltips: {
          position: "custom",
          backgroundColor: "#FFFFFF",
          bodyFontColor: "#000000",
          borderWidth: 1,
          borderColor: "#eee",
          bodyFontFamily: "Cabin",
          displayColors: false,
          callbacks: {
            label: (tooltipItem, data) => {
              let label = data.extraLabels[tooltipItem.index] || "";
              let value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
              return value + " " + label;
            },
            title: () => {
              return "";
            },
          },
        },
        plugins: {
          datalabels: {
            font: {
              family: "Cabin",
            },
            align: -45,
            anchor: "start",
            clamp: true,
            offset: 14,
            formatter: (value, context) => {
              return context.chart.data.extraLabels[context.dataIndex];
            },
          },
        },
      },
      heatmapChunkRequestCounter: 0,
      heatmapActivityDates: [],
      heatmapData: [],
      heatmapOptions: {
        chart: {
          height: 220,
          type: "heatmap",
          toolbar: {
            show: false,
          },
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        legend: {
          show: false,
        },
        plotOptions: {
          heatmap: {
            colorScale: {
              ranges: [
                {
                  from: 0,
                  to: 10,
                  name: "lowest",
                  color: "#F1F2F6",
                },
                {
                  from: 11,
                  to: 30,
                  name: "low",
                  color: "#C5C8EB",
                },
                {
                  from: 31,
                  to: 50,
                  name: "medium",
                  color: "#747CD0",
                },
                {
                  from: 51,
                  to: 75,
                  name: "high",
                  color: "#5057AF",
                },
                {
                  from: 75,
                  to: 100000000,
                  name: "extreme",
                  color: "#262C70",
                },
              ],
            },
          },
        },
        yaxis: {
          labels: {
            formatter: function (val, index) {
              return index % 2 !== 0 ? val : "";
            },
          },
        },
        tooltip: {
          y: {
            formatter: function (value) {
              return value;
            },
            title: {
              formatter: (seriesName) => {
                const h = seriesName.substring(0, 2);
                let next = parseInt(h) + 2;
                next = " - " + next + ":00";
                return seriesName + next;
              },
            },
          },
        },
      },
      projectHotLeadsCount: 0,
      projectDeadLeadsCount: 0,
      projectActionRequiredLeadsCount: 0,
      liveVisitors: [],
    };
  },
  created() {
    let vm = this;

    vm.initActivityFeeds();
    vm.loadProjects();

    if (vm.isHeatmapChartEnabled) {
      vm.loadActivities4HeatmapChart(new Date());
    }
  },
  methods: {
    ...mapActions(["getProjectsActivityFeeds", "activityFeedsApiRequest", "getProjectsStats"]),
    setText(client, project) {
      if (this.$windowWidth < 767) {
        return "<b>" + client + "</b> - <b>" + project + "</b><br/>";
      } else {
        return "";
      }
    },
    initActivityFeeds() {
      this.getProjectsActivityFeeds({ type: "Dropdown", localLoading: true });
    },
    loadProjects() {
      if (this.teamCan("project-statistics")) {
        const vm = this;
        vm.getProjectsStats({
          setListsSettings: false,
        }).then(() => {
          if (vm.projectsStats) {
            vm.setChartsData();
            vm.projectHotLeadsCount = vm.projectsStats.projects.hot_lead_count;
            vm.projectDeadLeadsCount = vm.projectsStats.projects.dead_lead_count;
            vm.projectActionRequiredLeadsCount = vm.projectsStats.projects.action_required_lead_count;
          }
        });
      }
    },

    loadActivities4HeatmapChart(fromDate) {
      let vm = this;

      let payload = {
        apiMethod: "activitiesList",
        params: {
          event_type: "",
          from: fromDate.toISOString(),
          client_uid: "",
          project_uid: "",
        },
      };

      vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");

      vm.activityFeedsApiRequest(payload)
        .then((data) => {
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_ENDED");

          this.liveVisitors = this.liveVisitors.concat(this.calculateLiveUsers(data.items));
          this.liveVisitors = [...new Set([...this.liveVisitors, ...this.calculateLiveUsers(data.items)])];

          let timestamp28DaysAgo = new Date().getTime() - 28 * 24 * 60 * 60 * 1000;
          let lastEventAtStr = data["last_event_at"];
          let lastEventAt = new Date(lastEventAtStr);

          let nextChunkFromStr = data["next_chunk_from"];
          let nextChunkFrom = new Date(nextChunkFromStr);

          let requestNextChuck = true;
          if (lastEventAt.getTime() < timestamp28DaysAgo) {
            requestNextChuck = false;
          }

          let responseItems = data.items;
          let activityDates = vm.parseActivityDatesFromFeedResponseItems(responseItems);
          vm.heatmapActivityDates = vm.heatmapActivityDates.concat(activityDates);

          if (activityDates.length === 0) {
            requestNextChuck = false;
          }

          // this check shouldn't be necessary and it is just a fallback to stop the request
          // in case last chunk date from the API is incorrect to prevent an endless loop
          if (vm.heatmapChunkRequestCounter > 10) {
            requestNextChuck = false;
          }

          if (requestNextChuck) {
            vm.loadActivities4HeatmapChart(nextChunkFrom);
            vm.heatmapChunkRequestCounter++;
          } else {
            vm.heatmapData = vm.convertActivityDates2HeatmapData(vm.heatmapActivityDates);
          }
        })
        .catch((err) => {
          console.log("error: ", err);
          vm.$store.commit("GLOBAL_CUSTOM_LOADING_STARTED");
        });
    },
    initChartsData() {
      this.pageviewsDoughnutChartData = JSON.parse(JSON.stringify(this.initDoughnutChartData));
      this.projectsBarChartData = JSON.parse(JSON.stringify(this.initBarChartData));
      this.messagesBarChartData = JSON.parse(JSON.stringify(this.initBarChartData));
    },
    setChartsData() {
      this.initChartsData();
      this.setChartData(this.pageviewsDoughnutChartData, this.projectsStats.pageviews, "pageviews");
      this.setChartData(this.projectsBarChartData, this.projectsStats.projects, "projects");
      this.setChartData(this.messagesBarChartData, this.projectsStats.messages, "messages");
    },
    setChartData(chart, stats, chartName) {
      let label = "";
      let data = [];
      chart.extraLabels = [];
      chart.labels = [];
      switch (chartName) {
        case "messages":
          label = "Messages";
          chart.extraLabels.push(this.$t("projectsStats.with" + label));
          chart.labels.push(stats.items.projects.total);
          data.push(stats.items.projects.total);
          chart.extraLabels.push(this.$t("projectsStats.without" + label));
          chart.labels.push(stats.items.na.total);
          data.push(stats.items.na.total);
          chart.filterKey = "has_messages";
          chart.filterValues = [true, false];
          this.$set(chart.datasets, 0, {
            data: data,
            backgroundColor: this.chartsBackgroundColors,
            align: "start",
          });
          break;
        case "pageviews":
          Object.keys(stats.items).forEach((key) => {
            chart.extraLabels.push(stats.items[key].template_name + " - " + stats.items[key].page_name);
            chart.labels.push(stats.items[key].total);
            data.push(stats.items[key].total);
            chart.filterKey = "with_pageviewed";
            chart.filterValues.push(stats.items[key].page_uid);
          });
          console.log("labels", chart.extraLabels, chart.labels);
          this.$set(chart.datasets, 0, {
            data: data,
            backgroundColor: this.chartsBackgroundColors,
            align: "start",
          });
          break;
        case "projects":
          label = "Projects";
          chart.extraLabels.push(this.$t("projectsStats.new" + label));
          chart.labels.push(stats.items.new.total);
          data.push(stats.items.new.total);
          chart.extraLabels.push(this.$t("projectsStats.posted" + label));
          chart.labels.push(stats.items.posted.total);
          data.push(stats.items.posted.total);
          chart.extraLabels.push(this.$t("projectsStats.visited" + label));
          chart.labels.push(stats.items.visited.total);
          data.push(stats.items.visited.total);
          chart.filterKey = ["is_posted", "is_visited"];
          chart.filterValues = [
            [false, false],
            [true, false],
            ["", true],
          ];
          this.$set(chart.datasets, 0, {
            data: data,
            backgroundColor: this.projectChartBackgroundColors,
            align: "start",
          });
          break;
        default:
      }
    },
    goToProjects(chart) {
      this.$goTo("Projects", null, { barChart: chart });
    },
    goToProjectsFromSource(source) {
      this.$goTo("Projects", null, { from: source });
    },

    /**
     * Helper method to calculate live users for the last 10 minutes from the activity dates
     *
     * @param activityFeedResponseItems
     * @returns {[]}
     */
    calculateLiveUsers(activityFeedResponseItems) {
      let liveVisitors = [];
      let timestamp10MinAgo = new Date().getTime() - 10 * 60 * 1000;
      let eventTypes = ["FileDownload", "FilePreview", "FileUpload", "PageView", "ProjectMessage"];

      for (let i = 0; i < activityFeedResponseItems.length; i++) {
        eventTypes.forEach((eventType) => {
          activityFeedResponseItems[i]["events"][eventType].forEach((responseItemEventItem) => {
            let createdAt = new Date(responseItemEventItem.created_at);
            if (
              createdAt.getTime() > timestamp10MinAgo &&
              responseItemEventItem.visitor.uid &&
              !liveVisitors.includes(responseItemEventItem.visitor.uid)
            ) {
              liveVisitors.push(responseItemEventItem.visitor.uid);
            }
          });
        });
      }

      return liveVisitors;
    },

    /**
     * Helper method to parse the activity dates from the given activity feed response
     *
     * @param activityFeedResponseItems
     * @returns {[]}
     */
    parseActivityDatesFromFeedResponseItems(activityFeedResponseItems) {
      let vm = this;
      let activityDates = [];

      for (let a = 0; a < activityFeedResponseItems.length; a++) {
        let responseItem = activityFeedResponseItems[a];
        let tmpActivityDates = vm.parseActivityDatesFromFeedResponseItem(responseItem);

        activityDates = activityDates.concat(tmpActivityDates);
      }

      return activityDates;
    },

    /**
     * Helper method to parse the event types within the given activity feed response object
     *
     * @param responseItem
     * @returns {[]}
     */
    parseActivityDatesFromFeedResponseItem(responseItem) {
      let vm = this;

      let activityDates = [];
      let eventTypes = ["FileDownload", "FilePreview", "FileUpload", "PageView", "ProjectMessage"];
      for (let a = 0; a < eventTypes.length; a++) {
        let eventType = eventTypes[a];
        let tmpActivityDates = vm.parseActivityDatesFromFeedResponseItemEventType(responseItem, eventType);

        activityDates = activityDates.concat(tmpActivityDates);
      }

      return activityDates;
    },

    /**
     * Helper method to parse the activity dates on the given activity feed by checking the
     * specific event type within the response object
     *
     * @param responseItem
     * @param eventType
     * @returns {[]}
     */
    parseActivityDatesFromFeedResponseItemEventType(responseItem, eventType) {
      let events = responseItem["events"][eventType];

      if (events.length === 0) {
        return [];
      }

      let activityDates = [];
      let timestamp28DaysAgo = new Date().getTime() - 28 * 24 * 60 * 60 * 1000;

      for (let a = 0; a < events.length; a++) {
        let event = events[a];
        let createdAtStr = event["created_at"];
        let createdAt = new Date(createdAtStr);

        if (createdAt.getTime() > timestamp28DaysAgo) {
          activityDates.push(createdAt);
        }
      }

      return activityDates;
    },

    /**
     * Helper method to convert an array of activity dates to the format processed by the headmap widget.
     *
     * @param activityDates
     * @returns {[]}
     */
    convertActivityDates2HeatmapData(activityDates) {
      let days = [
        { name: "Mo", dayOfWeek: 1, dayIdx: 0 },
        { name: "Di", dayOfWeek: 2, dayIdx: 1 },
        { name: "Mi", dayOfWeek: 3, dayIdx: 2 },
        { name: "Do", dayOfWeek: 4, dayIdx: 3 },
        { name: "Fr", dayOfWeek: 5, dayIdx: 4 },
        { name: "Sa", dayOfWeek: 6, dayIdx: 5 },
        { name: "So", dayOfWeek: 7, dayIdx: 6 },
      ];

      let timespans = [
        {
          name: "22:00",
          startHour: 22,
          rangeMinutes: 60 + 59,
          timespanIdx: 0,
        },
        {
          name: "20:00",
          startHour: 20,
          rangeMinutes: 60 + 59,
          timespanIdx: 1,
        },
        {
          name: "18:00",
          startHour: 18,
          rangeMinutes: 60 + 59,
          timespanIdx: 2,
        },
        {
          name: "16:00",
          startHour: 16,
          rangeMinutes: 60 + 59,
          timespanIdx: 3,
        },
        {
          name: "14:00",
          startHour: 14,
          rangeMinutes: 60 + 59,
          timespanIdx: 4,
        },
        {
          name: "12:00",
          startHour: 12,
          rangeMinutes: 60 + 59,
          timespanIdx: 5,
        },
        {
          name: "10:00",
          startHour: 10,
          rangeMinutes: 60 + 59,
          timespanIdx: 6,
        },
        {
          name: "08:00",
          startHour: 8,
          rangeMinutes: 60 + 59,
          timespanIdx: 7,
        },
        {
          name: "06:00",
          startHour: 6,
          rangeMinutes: 60 + 59,
          timespanIdx: 8,
        },
        {
          name: "04:00",
          startHour: 0,
          rangeMinutes: 5 * 60 + 59,
          timespanIdx: 9,
        },
      ];

      let heatmapData = [];

      // prepare the initial structure of the heat map data based on the
      // timespans and the days
      for (let timespanIdx = 0; timespanIdx < timespans.length; timespanIdx++) {
        let timespanName = timespans[timespanIdx]["name"];

        let dataRow = [];
        for (let dayIdx = 0; dayIdx < days.length; dayIdx++) {
          let day = days[dayIdx];
          let dayName = day["name"];

          dataRow.push({
            x: dayName,
            y: 0,
          });
        }

        heatmapData.push({
          name: timespanName,
          data: dataRow,
        });
      }

      // fill the actual data from the activities into the headmap data structure
      activityDates.forEach(function (activityDate) {
        let activityDayOfWeek = activityDate.getDay();
        let activityHourOfDay = activityDate.getHours();
        let activityMinuteOfHour = activityDate.getMinutes();
        let activityMinuteOfDay = activityHourOfDay * 60 + activityMinuteOfHour;

        let timespanIdx = 0;
        timespans.forEach(function (timespan) {
          let timespanStartMinuteOfDay = timespan["startHour"] * 60;
          let timespanEndMinuteOfDay = timespan["startHour"] * 60 + timespan["rangeMinutes"];

          if (activityMinuteOfDay > timespanStartMinuteOfDay && activityMinuteOfDay < timespanEndMinuteOfDay) {
            timespanIdx = timespan["timespanIdx"];
          }
        });

        let dayIdx = 0;
        days.forEach(function (day) {
          if (activityDayOfWeek === day["dayOfWeek"]) {
            dayIdx = day["dayIdx"];
          }
        });

        let visitCount = heatmapData[timespanIdx]["data"][dayIdx]["y"];
        heatmapData[timespanIdx]["data"][dayIdx]["y"] = visitCount + 1;
      });

      return heatmapData;
    },
  },
  computed: {
    ...mapGetters({
      teams: "auth_get_teams",
      showTips: "global_get_show_tips",
      showAlways: "global_get_show_tips_icon",
      projectsStats: "projects_get_projects_stats",
      activityFeedItemsForDropdown: "projects_get_activity_feed_items_for_dropdown",
    }),
    isLiveVisitorsCounterEnabled() {
      return false;
      //return (
      //  this.teams[this.$route.params.team].account &&
      //  this.teams[this.$route.params.team].account.team.attributes.livevisitorswidget
      //);
    },
    isHeatmapChartEnabled() {
      return (
        this.teams[this.$route.params.team].account &&
        this.teams[this.$route.params.team].account.team.attributes.heatmap_chart
      );
    },
    isImportantProjectsWidgetsEnabled() {
      return (
        this.teams[this.$route.params.team].account &&
        this.teams[this.$route.params.team].account.team.attributes.important_projects_widget
      );
    },
  },
};
</script>

<style lang="scss">
.stats-teaser {
  height: 225px;
  width: 335px;
  &.created-projects {
    filter: blur(8px);
    -webkit-filter: blur(8px);
    background-image: url("../assets/svg/dashboard-created-projects.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
  &.project-status {
    filter: blur(8px);
    -webkit-filter: blur(8px);
    background-image: url("../assets/svg/dashboard-project-status.svg");
    background-position: center;
    background-repeat: no-repeat;
    background-size: cover;
  }
}
</style>
